import { ref, useContext, useRouter } from "@nuxtjs/composition-api";
import { useUiNotification } from "~/composables";
import cancelorder from "~/modules/customer/customQueries/cancelorder.gql"

export function useOrderCancel() {
    const loading = ref(false);
    const router = useRouter();
    const { app } = useContext();
    const { send: sendNotification, notifications } = useUiNotification();

    const orderCancel = async (orderId: any, message: String) => {
        loading.value = true;
        try {
            const { data, errors } = await app.context.$vsf.$magento.api.customQuery({
                query: cancelorder,
                queryVariables: {
                    orderId: orderId,
                    message: message
                }
            });
            
            if (errors) {
                sendNotification({
                    id: Symbol('product_removed'),
                    message: 'Something went wrong. Please try again later.',
                    type: 'danger',
                    icon: 'error',
                    persist: false,
                    title: 'Unable to cancel',
                });
                return;
            }

            if (!data.cancelOrder.status) {
                sendNotification({
                    id: Symbol('product_removed'),
                    message: data.cancelOrder.message,
                    type: 'danger',
                    icon: 'error',
                    persist: false,
                    title: 'Unable to cancel',
                });
                return;
            }

            sendNotification({
                id: Symbol('product_removed'),
                message: data.cancelOrder.message,
                type: 'success',
                icon: 'success',
                persist: false,
                title: 'Order cancelled',
            });
            
            await router.push(app.localePath('/customer/order-history'));
        } catch (err) {
            console.log(err);
        } finally {
            loading.value = false;  
        }
    }

    return {
        orderCancel,
        loading
    };
}